export default "__VITE_ASSET___yLoUWv5__"